import {
  AdminLayout,
  SourceIdentifierInterface,
  useSource,
  useTranslation,
} from "@opendash/core";
import { WidgetStatic } from "@opendash/plugin-monitoring";
import {
  DataFetchingOptionsInterface,
  DataItemDimensionIdentifierInterface,
  DataItemIdentifierInterface,
  useDataService,
} from "@opendash/plugin-timeseries";
import { AdminToolbar } from "@opendash/ui";
import { Alert, Button, Divider, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";

type Props = {};

const { Title } = Typography;

export const MonitoringPage = observer((props: Props) => {
  const t = useTranslation();
  const [source] = useSource();
  const DataService = useDataService();

  const [editWidgets, setEditWidgets] = useState(false);

  const widgetConfig1 = {
    _history: {
      unit: "week",
      value: 1,
      historyType: "relative",
      live: true,
    } as DataFetchingOptionsInterface,
    _sources: [source.tag] as SourceIdentifierInterface[],
    _items: Array.from(DataService.getItems(source.tag)).map((item) => [
      source.tag,
      item[1].id,
    ]) as DataItemIdentifierInterface[],
    _dimensions: Array.from(DataService.getItems(source.tag)).map((item) => [
      source.tag,
      item[1].id,
      0,
    ]) as DataItemDimensionIdentifierInterface[],
    type: "table",
  };

  const widgetConfig2 = {
    _history: {
      unit: "week",
      value: 1,
      historyType: "relative",
      live: true,
    } as DataFetchingOptionsInterface,
    _sources: [source.tag] as SourceIdentifierInterface[],
    _items: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [source.tag, item[1].id]) as DataItemIdentifierInterface[],
    _dimensions: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [
        source.tag,
        item[1].id,
        0,
      ]) as DataItemDimensionIdentifierInterface[],
    type: "column",
    operation: "count",
    roundto: 0,
    onlytrue: true,
    legend: true,
  };

  const widgetConfig3 = {
    _history: {
      unit: "day",
      value: 1,
      historyType: "relative",
      live: true,
    } as DataFetchingOptionsInterface,
    _sources: [source.tag] as SourceIdentifierInterface[],
    _items: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [source.tag, item[1].id])
      .splice(0, 1) as DataItemIdentifierInterface[],
    _dimensions: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [source.tag, item[1].id, 0])
      .splice(0, 1) as DataItemDimensionIdentifierInterface[],
    type: "column",
    legend: true,
  };

  const widgetConfig4 = {
    _history: {
      unit: "day",
      value: 1,
      historyType: "relative",
      live: true,
    } as DataFetchingOptionsInterface,
    _sources: [source.tag] as SourceIdentifierInterface[],
    _items: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [source.tag, item[1].id])
      .splice(0, 1) as DataItemIdentifierInterface[],
    _dimensions: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [source.tag, item[1].id, 0])
      .splice(1, 1) as DataItemDimensionIdentifierInterface[],
    type: "column",
    legend: true,
  };

  const widgetConfig5 = {
    _history: {
      unit: "day",
      value: 1,
      historyType: "relative",
      live: true,
    } as DataFetchingOptionsInterface,
    _sources: [source.tag] as SourceIdentifierInterface[],
    _items: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [source.tag, item[1].id])
      .splice(2, 1) as DataItemIdentifierInterface[],
    _dimensions: Array.from(DataService.getItems(source.tag))
      .filter((item) =>
        item[1].valueTypes.some(
          (valueType) =>
            valueType.type === "Boolean" && valueType.name.includes("stoerung")
        )
      )
      .map((item) => [source.tag, item[1].id, 0])
      .splice(2, 1) as DataItemDimensionIdentifierInterface[],
    type: "column",
    legend: true,
  };

  // useEffect(() => {
  //   //Sum up all values of the items if the valueType is boolean
  //   const x = Array.from(DataService.getItems(source.tag))
  //     .filter((item) =>
  //       item[1].valueTypes.some((valueType) => valueType.type === "Boolean")
  //     )
  //     .map(async (item) => {
  //       return (
  //         await DataService.fetchValues(item[1], {
  //           unit: "week",
  //           value: 1,
  //           historyType: "relative",
  //           live: true,
  //         })
  //       ).reduce(
  //         (accDataItem, currDataItem) =>
  //           accDataItem +
  //           currDataItem.value.reduce(
  //             (acc: number, curr) =>
  //               typeof curr === "boolean" && curr ? acc + 1 : acc + 0,
  //             0
  //           ),
  //         0
  //       );
  //     });
  //   Promise.all(x).then((values) => {
  //     console.log(values);
  //   });
  // }, []);

  return (
    <AdminLayout contentPadding>
      <AdminToolbar
        title={t("maintenance:monitoring.view.headline")}
        actions={
          <Flex gap={12}>
            <Button
              onClick={() => {
                setEditWidgets(!editWidgets);
              }}
            >
              {editWidgets ? "Speichern" : "Bearbeiten"}
            </Button>
          </Flex>
        }
      />
      <div className="od-page-main">
        <Flex gap={48} vertical>
          <Flex gap={12} vertical>
            <Title level={3}>Werteübersicht</Title>
            <Alert
              message="Übersicht über alle Datenpunkte zu der ausgewählten Quelle"
              type="info"
            />
            <div style={{ height: "500px" }}>
              <WidgetStatic
                type={"opendash-widget-table"}
                config={widgetConfig1}
                edit={editWidgets}
              />
            </div>
          </Flex>
          <Divider />
          <Flex gap={12} vertical>
            <Title level={3}>Störungsanzahl</Title>
            <Alert
              message="Anzahl der Störungen in der letzten Woche"
              type="info"
            />
            <div style={{ height: "500px" }}>
              <WidgetStatic
                type={"openservice-number-of-issues"}
                config={widgetConfig2}
                edit={editWidgets}
              />
            </div>
          </Flex>
          <Divider />
          <Flex gap={12}>
            <Flex gap={12} vertical>
              <Title level={3}>MTBF - Mean time between failures</Title>
              <Alert
                message="MTBF (Mean Time Between Failures) ist die durchschnittliche Zeitspanne zwischen reparablen Ausfällen eines technischen Produkts."
                type="info"
              />
              <div style={{ height: "500px" }}>
                <WidgetStatic
                  type={"openservice-mean-time-between-failures"}
                  config={widgetConfig3}
                  edit={editWidgets}
                />
              </div>
            </Flex>
            <Flex gap={12} vertical>
              <Title level={3}>MTBF - Mean time between failures</Title>
              <Alert
                message="MTBF (Mean Time Between Failures) ist die durchschnittliche Zeitspanne zwischen reparablen Ausfällen eines technischen Produkts."
                type="info"
              />
              <div style={{ height: "500px" }}>
                <WidgetStatic
                  type={"openservice-mean-time-between-failures"}
                  config={widgetConfig4}
                  edit={editWidgets}
                />
              </div>
            </Flex>
            <Flex gap={12} vertical>
              <Title level={3}>MTBF - Mean time between failures</Title>
              <Alert
                message="MTBF (Mean Time Between Failures) ist die durchschnittliche Zeitspanne zwischen reparablen Ausfällen eines technischen Produkts."
                type="info"
              />
              <div style={{ height: "500px" }}>
                <WidgetStatic
                  type={"openservice-mean-time-between-failures"}
                  config={widgetConfig5}
                  edit={editWidgets}
                />
              </div>
            </Flex>
          </Flex>
        </Flex>
      </div>
    </AdminLayout>
  );
});
